import { useTranslations } from 'next-intl'
import { z } from 'zod'

export const createZSignIn = (t: ReturnType<typeof useTranslations<'login'>>) =>
  z.object({
    username: z
      .string()
      .min(1, {
        message: t('email_error_empty_format'),
      })
      .email({
        message: t('email_error_invalid_format'),
      }),
    password: z.string().min(1, {
      message: t('password_error_empty_format'),
    }),
    rememberMe: z.boolean(),
  })

export type TSignIn = z.infer<ReturnType<typeof createZSignIn>>
